import {buildUser} from '@teladoc/statsig';
import {ACTIVE_PROVIDER_GROUP_ID} from '@teladoc/fe-ccm/ui/config';
import {MEMBER_ID} from '@/config';
import CommonUtils from '@/utils/common-utils';

const STATSIG_TIER_BY_ENVIRONMENT = {
    local: 'development',
    production: 'production',
};

export function getStatsigOptions() {
    const environment =
        window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT;
    const tier = STATSIG_TIER_BY_ENVIRONMENT[environment] ?? 'staging';

    return {environment: {tier}};
}

export function formatStatsigIdentity(user) {
    // telapp member_id cookie — the single, consistent identity oneapp sets on
    // auth. One ID namespace keeps Statsig bucketing/exposure stable per member.
    const userID = CommonUtils.getCookie({key: MEMBER_ID});
    // groupID: the member's active provider/benefit unit (Teladoc group ID) —
    // the active group_id cookie, falling back to the first provider's id.
    const groupID =
        CommonUtils.getCookie({key: ACTIVE_PROVIDER_GROUP_ID}) ||
        user?.providers?.providerData?.providersList?.[0]?.teladocGroupId;

    // "groupID" would be the preferred name for Statsig,
    // but since the mobile apps already use "unit_id",
    // the web app should align with them.
    // eslint-disable-next-line camelcase
    const custom = groupID ? {unit_id: groupID} : null;

    return buildUser({userID, custom});
}
